module.exports = __webpack_public_path__ + "static/media/top_section_illu.977e5cba.svg";